import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"

import { cn } from "@/lib/utils"

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

/**
 * Magnidrop matte tooltip.
 * Ultra-clean minimalist look: dark matte background, thin sunset-orange border,
 * subtle shadow. Uniform across light & dark themes to keep the brand voice consistent.
 */
const TooltipContent = React.forwardRef(({ className, sideOffset = 8, children, showArrow = true, ...props }, ref) => (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        "z-50 overflow-hidden rounded-md px-3 py-2 text-xs leading-relaxed",
        // Dark matte surface — brand consistent in both themes
        "bg-[#0E1117] text-neutral-100",
        // Thin sunset orange border accent
        "border border-[#FF6B35]/40",
        // Ultra-soft shadow, no glossy glow
        "shadow-[0_8px_24px_-8px_rgba(0,0,0,0.5)]",
        // Animations
        "animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
        "data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        "origin-[--radix-tooltip-content-transform-origin]",
        className
      )}
      {...props}
    >
      {children}
      {showArrow && (
        <TooltipPrimitive.Arrow
          width={10}
          height={5}
          className="fill-[#0E1117] drop-shadow-[0_1px_0_rgba(255,107,53,0.35)]"
        />
      )}
    </TooltipPrimitive.Content>
  </TooltipPrimitive.Portal>
))
TooltipContent.displayName = TooltipPrimitive.Content.displayName

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }
